module.exports={
  "office-P": "President",
  "office-S": "Senate",
  "office-G": "Governor",
  "office-H": "House",
  "office-I": "Ballot Initiatives",
  "GOP": "R",
  "Dem": "D",
  "long-GOP": "Republican",
  "short-GOP": "R",
  "long-Dem": "Democrat",
  "short-Dem": "D",
  "credits": "Designed and developed by Jacob Fenton, Alyson Hurt, Koko Nakajima and Kaitlyn Radde\n\nEdited by Emily Alfin-Johnson, Heidi Glenn, Megan Pratz, Acacia Squires, Katherine Swartz and Benjamin Swasey",
  "sources": "Sources: Electoral results from the AP. Candidates receiving less than 5% support not shown individually.",
  "trends_footnote": "Demographic trends not shown for special elections or states with fewer than 10 counties reporting above 50%.",
  "omitted_county_footer": "Counties where leading parties differ from statewide leading parties are omitted.",
  "unemployment_footnote": "Unemployment rates from the Bureau of Labor Statistics.",
  "margins_footnote": "2020 presidential margins from the AP and may vary slightly from state-certified final results.",
  "lambda_url": "https://emd0pcocya.execute-api.us-east-1.amazonaws.com/test/image",
  "lambda_css_url": "https://apps.npr.org/dailygraphics/graphics/election-gfx-social-styles-20221103/graphic.css"
}